import assetManifest from "./assetManifest.js";

export function resolvePackageAssetUrl(value) {
  if (typeof value !== "string") {
    return value;
  }

  return assetManifest[value] ?? value;
}

export function deepResolvePackageAssetUrls(value) {
  if (Array.isArray(value)) {
    return value.map(deepResolvePackageAssetUrls);
  }

  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, itemValue]) => [
        key,
        deepResolvePackageAssetUrls(itemValue),
      ]),
    );
  }

  return resolvePackageAssetUrl(value);
}
